import $ from "jquery"; // Import jQuery
import React, { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import useFocusedRowHighlight from "../../../../hooks/useFocusedRowHighlight";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";
import Select from "react-select";

const CreateJig = () => {
  // Need stock Validation of Qty here
  const { checkRequiredFields } = useRequiredFields();
  const { getRowProps } = useFocusedRowHighlight();
  const navigate = useNavigate();
  // const { id } = useParams();
  const deflautSearchValue = useRef();
  const searchTimeout = useRef(null); // Ref to store the debounce timeout

  const [inputs, setInputs] = useState({
    receipt_no: "",
    production_work_order_id: "",
    date: "",
    receive_date: "",
    entry_date: new Date().toISOString().split("T")[0],
    copy_type: "",
    purchase_type: "",
    shortplan_id: "",
    planning_id: "",
    from_department: "",
    to_department: "",
    status: "requested",
    remarks: "",
    filter_cake_id: "",
  });

  const [list, setList] = useState([]);
  const [error, setError] = useState({});
  const [planningId, setPlanningId] = useState({});
  const [planningOptions, setPlanningOptions] = useState([]);
  const [role, setRole] = useState("");
  const [itemLoading, setItemLoading] = useState(false);
  const [searchProducts, setSearchProducts] = useState("");
  const [random, setRandom] = useState();
  const [loading, setLoading] = useState(false);
  const [allItemsWithInput, setAllItemsWithInput] = useState(new Map());
  const [showPagination, setShowPagination] = useState(true);
  const [filterCakeOptions, setFilterCakeOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getUniquePlanningData = (items) => {
    const map = new Map();

    items.forEach((item) => {
      const key = [
        item.product_id,
        item.shape_id,
        item.production_work_order?.id,
        item.production_work_order?.company?.id,
        item.production_work_order_item?.glaze_id ?? "",
        item.production_work_order_item?.decoration_code ?? "",
      ].join("_");

      if (!map.has(key)) {
        map.set(key, item);
      }
    });

    return Array.from(map.values());
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const resRole = await Http.get("/staff-type-check");
      const fetchedRole = resRole.data;
      setRole(fetchedRole);
      // // Set only unique data
      // setPlanningOptions(planningData);

      const shortPlanning = await Http.get("/short-planning");
      const short = shortPlanning.data;
      setPlanningOptions(short);
      const firstPlanning = short[0];
      if (short.length > 0) {
        const planning_id = shortPlanning.data.find(
          (item) => item.id == firstPlanning.id,
        )?.planning_id;
        console.log(inputs, "planning_id");
        // Automatically select the first planning and set in inputs
        setInputs((prevInputs) => ({
          ...prevInputs,
          shortplan_id: firstPlanning.id, // Assuming the ID field for planning
          planning_id: planning_id,
        }));
        // Load items for the first planning
        await handlePlanningChange(firstPlanning.id, planning_id);
      }

      // Fetch the receipt number
      const resReceiptNo = await Http.get(
        "/last-code-increment-by-one/production_finished_goods/receipt_no/P",
      );
      const receiptNo = resReceiptNo.data; // Assuming the API returns the receipt number directly

      // Set the fetched receipt number to inputs
      setInputs((prevInputs) => ({
        ...prevInputs,
        receipt_no: receiptNo,
      }));

      // Fetch filter cake options
      const resFilterCake = await Http.get("/product-list-body-return");
      setFilterCakeOptions(resFilterCake.data);
      setInputs((prevInputs) => ({
        ...prevInputs,
        filter_cake_id: 1,
      }));
    } catch (e) {
      console.error("Error fetching data:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    $("body").addClass("collapse-menu");
    // $("body").toggleClass("show-left");
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const [originalList, setOriginalList] = useState([]);
  // const handleInputChange = (e, index) => {
  //   const { name, value } = e.target;
  //   const updatedList = [...list];
  //   // let inputValue = parseFloat(value) || 0;
  //   let inputValue = value === "" ? 0 : parseFloat(value);

  //   if (name === "transfer_qty" || name === "return_qty") {
  //     let transferQty = list[index]?.transfer_qty || 0;
  //     let returnQty = list[index]?.return_qty || 0;

  //     if (name === "transfer_qty") {
  //       transferQty = inputValue;
  //     } else {
  //       returnQty = inputValue;
  //     }
  //     // Check if the closing balance would be less than 0
  //     const closingBalance =
  //       (list[index].current_stock || 0) +
  //       (list[index].production_qty || 0) -
  //       (transferQty || 0) -
  //       (returnQty || 0);

  //     // Adjust inputValue if it causes closing balance to be less than 0
  //     console.log(closingBalance, "closingBalance");
  //   }

  //   updatedList[index][name] = inputValue;
  //   if (name === "green_weight") {
  //     const stock = Number(
  //       (filterCakeOptions.find((o) => o.value === inputs.filter_cake_id) || {})
  //         .stockQty || 0
  //     );
  //     const totalKg = updatedList.reduce(
  //       (sum, it) => sum + ((Number(it.green_weight) || 0) / 1000),
  //       0
  //     );
  //     const remaining = stock - totalKg;
  //     if (remaining < 0) {
  //       Swal.fire("Error!", "Filter cake stock cannot be less than 0", "error");
  //       updatedList[index][name] = 0;
  //     }
  //   }
  //   setList(updatedList);

  //   const itemId = updatedList[index].id;
  //   setAllItemsWithInput((prevMap) => {
  //     const newMap = new Map(prevMap);
  //     newMap.set(itemId, { ...updatedList[index] });
  //     return newMap;
  //   });
  // };

  const handleInputChange = (e, index, available_qty = null) => {
    let { name, value } = e.target;
    const updatedList = [...list];

    let inputValue = value === "" ? 0 : parseFloat(value);
    const currentItem = updatedList[index];

    const productId = currentItem.product_id;
    const shapeId = currentItem.shape_id;
    const tempList = [...updatedList];
    tempList[index][name] = inputValue;

    // New validation: Check if total filter cake consumption exceeds available stock
    if (name === "green_weight" || name === "production_qty") {
      const selectedFilterCake = filterCakeOptions.find(
        (o) => o.value == inputs.filter_cake_id,
      );
      const selectedStockQty = selectedFilterCake
        ? Number(selectedFilterCake.stockQty || 0)
        : 0;

      const totalConsumption = tempList.reduce((sum, item) => {
        const greenWeight = Number(item.green_weight) || 0;
        const productionQty = Number(item.production_qty) || 0;
        return sum + (greenWeight / 1000) * productionQty;
      }, 0);

      if (selectedStockQty - totalConsumption < 0) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Filter cake stock cannot be less than 0 after this change.",
        });
        inputValue = 0; // Revert to original value
      }
    }

    const newGroupProductionQty = tempList
      .filter(
        (item) =>
          item.product_id === productId &&
          (item.shape_id ?? 0) === (shapeId ?? 0),
      )
      .reduce((sum, item) => sum + (parseFloat(item.production_qty) || 0), 0);
    const newGroupTransferQty = tempList
      .filter(
        (item) =>
          item.product_id === productId &&
          (item.shape_id ?? 0) === (shapeId ?? 0),
      )
      .reduce((sum, item) => sum + (parseFloat(item.transfer_qty) || 0), 0);
    const newGroupBeforeLossQty = tempList
      .filter(
        (item) =>
          item.product_id === productId &&
          (item.shape_id ?? 0) === (shapeId ?? 0),
      )
      .reduce(
        (sum, item) => sum + (parseFloat(item.before_production_loss_qty) || 0),
        0,
      );
    const newGroupAfterLossQty = tempList
      .filter(
        (item) =>
          item.product_id === productId &&
          (item.shape_id ?? 0) === (shapeId ?? 0),
      )
      .reduce(
        (sum, item) => sum + (parseFloat(item.after_production_loss_qty) || 0),
        0,
      );
    const proposedAvailable =
      (currentItem.current_stock || 0) -
      (tempList[index].return_qty || 0) +
      newGroupProductionQty -
      newGroupTransferQty -
      newGroupAfterLossQty -
      newGroupBeforeLossQty;
    if (
      name === "production_qty" ||
      name === "transfer_qty" ||
      name === "before_production_loss_qty" ||
      name === "after_production_loss_qty" ||
      name === "return_qty"
    ) {
      /* artisan er 1st june er stock pawa porjonto eta temporary vabe off thakbe */
      if (proposedAvailable < 0) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "This value cannot be less than 0.",
        });
        inputValue = 0;
      }
      // */
    }

    // Update the value
    updatedList[index][name] = inputValue;

    const groupProductionQty = updatedList
      .filter(
        (it) =>
          it.product_id === currentItem.product_id &&
          (it.shape_id ?? 0) === (currentItem.shape_id ?? 0),
      )
      .reduce((sum, it) => sum + (parseFloat(it.production_qty) || 0), 0);
    const groupTransferQty = updatedList
      .filter(
        (it) =>
          it.product_id === currentItem.product_id &&
          (it.shape_id ?? 0) === (currentItem.shape_id ?? 0),
      )
      .reduce((sum, it) => sum + (parseFloat(it.transfer_qty) || 0), 0);
    const groupBeforeLossQty = updatedList
      .filter(
        (it) =>
          it.product_id === currentItem.product_id &&
          (it.shape_id ?? 0) === (currentItem.shape_id ?? 0),
      )
      .reduce(
        (sum, it) => sum + (parseFloat(it.before_production_loss_qty) || 0),
        0,
      );
    const groupAfterLossQty = updatedList
      .filter(
        (it) =>
          it.product_id === currentItem.product_id &&
          (it.shape_id ?? 0) === (currentItem.shape_id ?? 0),
      )
      .reduce(
        (sum, it) => sum + (parseFloat(it.after_production_loss_qty) || 0),
        0,
      );

    const closingBalance =
      (updatedList[index].current_stock || 0) -
      (updatedList[index].return_qty || 0) +
      groupProductionQty -
      groupTransferQty -
      groupAfterLossQty -
      groupBeforeLossQty -
      (updatedList[index].total_loss_qty || 0);

    updatedList[index].closing_balance = closingBalance;

    setList(updatedList);

    const itemId = updatedList[index].id;
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });

    setOriginalList((prevOriginalList) =>
      prevOriginalList.map((item, idx) =>
        item.id === updatedList[index].id ? { ...updatedList[index] } : item,
      ),
    );
  };

  const getGroupTransferQty = useCallback(
    (productId, shapeId) => {
      return list.reduce((sum, it) => {
        const sameProduct = it.product_id === productId;
        const sameShape = (it.shape_id ?? 0) === (shapeId ?? 0);
        return (
          sum +
          (sameProduct && sameShape ? parseFloat(it.transfer_qty) || 0 : 0)
        );
      }, 0);
    },
    [list],
  );
  const getGroupReturnQty = useCallback(
    (productId, shapeId) => {
      return list.reduce((sum, it) => {
        const sameProduct = it.product_id === productId;
        const sameShape = (it.shape_id ?? 0) === (shapeId ?? 0);
        return (
          sum + (sameProduct && sameShape ? parseFloat(it.return_qty) || 0 : 0)
        );
      }, 0);
    },
    [list],
  );
  const getGroupProductionQty = useCallback(
    (productId, shapeId) => {
      return list.reduce((sum, it) => {
        const sameProduct = it.product_id === productId;
        const sameShape = (it.shape_id ?? 0) === (shapeId ?? 0);
        return (
          sum +
          (sameProduct && sameShape ? parseFloat(it.production_qty) || 0 : 0)
        );
      }, 0);
    },
    [list],
  );

  const formSubmit = () => {
    if (!checkRequiredFields()) {
      return;
    }
    let allItemsArray = Array.from(allItemsWithInput.values());
    const stock = Number(
      (filterCakeOptions.find((o) => o.value == inputs.filter_cake_id) || {})
        .stockQty || 0,
    );
    const totalKg = allItemsArray.reduce(
      (sum, it) => sum + (Number(it.green_weight) || 0) / 1000,
      0,
    );
    if (stock - totalKg < 0) {
      Swal.fire("Error!", "Filter cake stock cannot be less than 0", "error");
      return;
    }
    if (inputs.filter_cake_id) {
      allItemsArray = allItemsArray.map((item) => ({
        ...item,
        filter_cake_id: inputs.filter_cake_id,
      }));
    }
    const formData = {
      ...inputs,
      items: allItemsArray,
    };

    // ADDED: confirmation prompt before submitting
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to submit this transfer?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, submit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      // if (!result.isConfirmed) return;
      if (!result.isConfirmed) {
        setIsSubmitting(false); // ADDED: reappear on cancel
        return;
      }

      Http.post(`/production-transfer`, formData)
        .then((res) => {
          navigate("/transfer-art", {
            state: { message: res.data.message, type: "success" },
          });
        })
        // .catch(function (e) {
        //   Swal.fire({
        //     title: "Error",
        //     text: e.response.data.errors.planning_id,
        //     icon: "error",
        //   });
        // });
        .catch((e) => {
          const responseData = e.response?.data;
          const errors = responseData?.errors;

          // Stock validation errors come back as a plain array of message strings
          if (Array.isArray(errors) && errors.length > 0) {
            Swal.fire({
              icon: "error",
              title: responseData.message || "Validation Error",
              html: `<ul style="text-align:left; margin:0; padding-left:20px;">
                         ${errors.map((msg) => `<li>${msg}</li>`).join("")}
                       </ul>`,
            });
            return;
          }

          // Fallback: laravel-style field validation errors (object, not array)
          setError(errors || {});
          Swal.fire({
            icon: "error",
            title: "Validation Error",
            text:
              responseData?.message ||
              "Something went wrong. Please check the form.",
          });
        });
    });
  };

  const handlePlanningChange = async (shortplan_id, planning) => {
    setLoading(true);
    if (!shortplan_id) return;
    // Reset all form data when planning changes
    // setList([]); // Clear the current list
    // setOriginalList([]); // Clear original list
    // setAllItemsWithInput(new Map()); // Clear the items map
    // setSearchProducts(""); // Clear search input

    // setPlanningId(planningId);
    const planning_id = planningOptions.find(
      (item) => item.id == shortplan_id,
    )?.planning_id;
    console.log(planning_id, "planning_id");
    setInputs((prevInputs) => ({
      ...prevInputs,
      shortplan_id: shortplan_id, // Update planning_id in inputs
      planning_id: planning ?? planning_id,
    }));
    try {
      /*const response2 = await Http.get(
        `/show-current-active-planning/${shortplan_id}?production=1`
        // `/planning/11?production=1&page=1&limit=10`
      );*/
      const response = await Http.get(
        `/current-active-short-plan?production=1`,
        // `/planning/11?production=1&page=1&limit=10`
      );
      // Fetch data based on selected planning ID

      // Process collection of short plans from response.data
      let allUpdatedFilteredItems = [];

      // Loop through each short plan in the collection
      response.data?.forEach((planData) => {
        // Extract production_transfer_info for mapping quantities
        const productionTransferInfo = planData?.production_transfer_info;
        const filteredItems = planData?.items;

        const updatedFilteredItems = filteredItems
          ?.map((item) => {
            const productId = item?.product_id;
            const planningItemId = item?.id;
            const existingItem = allItemsWithInput.get(item?.id);

            // Validate date condition if planning_for_glazing_and_jigger_item exists
            let isValidDate = true;
            if (item?.planning_for_glazing_and_jigger_item?.id) {
              const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
              const startDate =
                item?.planning_for_glazing_and_jigger_item?.start_date;
              const endDate =
                item?.planning_for_glazing_and_jigger_item?.end_date;

              // Check if today's date falls between start_date and end_date (inclusive)
              isValidDate = startDate <= today && today <= endDate;
            }

            // Only create baseItem if date validation passes
            if (!isValidDate) {
              return null; // Skip this item if date validation fails
            }

            const baseItem = {
              id: item?.id,
              shortplan_id: shortplan_id,
              shortplan_item_id: item?.planning_for_glazing_and_jigger_item?.id,
              planning_id: planning_id,
              product_id: productId,
              product_name: item?.product?.name,
              shape: item?.shape?.name,
              shape_id: item?.shape?.id,
              production_work_order: item?.production_work_order?.receipt_no,
              company: item?.production_work_order?.company?.name,
              product_code: item?.product.code,
              planning_qty:
                item?.planning_for_glazing_and_jigger_item?.required_qty,
              production_qty: 0,
              return_qty: 0,
              transfer_qty: "",
              machine:
                item?.planning_for_glazing_and_jigger_item?.machine?.name,
              total_production_qty:
                productionTransferInfo[planningItemId]?.production_qty || 0, // Map production_qty
              total_transfer_qty:
                productionTransferInfo[planningItemId]?.transfer_qty || 0, // Map transfer_qty
              current_stock:
                productionTransferInfo[planningItemId]?.current_stock || 0, // Added current_stock
              slice_weight: item?.slice_weight, // Example if qty is used as slice_weight
              closing_balance: 0, // Placeholder for closing balance
              remarks_delivery: "", // Set to empty or adjust if needed
              decoration_code:
                item?.production_work_order_item?.decoration_code,
              decoration_name:
                item?.production_work_order_item?.decoration_name,
              glaze_id: item?.production_work_order_item?.glaze_id,
              status: item?.production_work_order?.status,
            };

            return existingItem || baseItem;
          })
          .filter((item) => item !== null); // Filter out null items from date validation

        // Add items from this plan to the overall collection
        if (updatedFilteredItems && updatedFilteredItems.length > 0) {
          allUpdatedFilteredItems = [
            ...allUpdatedFilteredItems,
            ...updatedFilteredItems,
          ];
        }
      });

      // Set the combined results from all short plans
      setList(allUpdatedFilteredItems);
      setOriginalList(allUpdatedFilteredItems);
      // setPagination(response.data.pagination);

      // Update the global map with new items (only if they don't already exist)
      setAllItemsWithInput((prevMap) => {
        const newMap = new Map(prevMap);
        allUpdatedFilteredItems.forEach((item) => {
          if (!newMap.has(item.id)) {
            newMap.set(item.id, item);
          }
        });
        return newMap;
      });
      setLoading(false);
    } catch (error) {
      console.error("Error fetching products for planning:", error);
      Swal.fire(
        "Error!",
        "Failed to fetch products for the selected planning.",
        "error",
      );
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".fixed-header");
      if (header) {
        // Add null check
        if (window.scrollY > 100) {
          header.classList.add("header-scrolled");
        } else {
          header.classList.remove("header-scrolled");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup function
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const cols = [{ field: "name", header: "Item" }];
  // const handleSearchProduct = async (e, page = 1) => {
  //   setLoading(true);
  //   const searchValue = e.target.value;
  //   setSearchProducts(searchValue);
  //   setShowPagination(false);
  //   // deflautSearchValue(searchValue);
  //   const planningId = inputs.planning_id;
  //   if (searchValue.trim() === "") {
  //     // Restore original list when input is empty
  //     // setList(originalList);
  //     setShowPagination(true);
  //     handlePlanningChange(planningId, page);
  //     return;
  //   } else {
  //     const response = await Http.post(`/search-products`, {
  //       search: searchValue,
  //       planningId,
  //     });

  //     // Extract production_transfer_info for mapping quantities
  //     const productionTransferInfo = response?.data?.production_transfer_info;
  //     const filteredItems = response?.data?.items;

  //     const updatedFilteredItems = filteredItems.map((item) => {
  //       const productId = item?.product_id;
  //       const planningItemId = item?.id;
  //       const existingItem = allItemsWithInput.get(item?.id);

  //       const baseItem = {
  //         id: item?.id,
  //         planning_id: item?.planning_id,
  //         product_id: productId,
  //         product_name: item?.product?.name,
  //         shape: item?.shape?.name,
  //         production_work_order: item?.production_work_order?.receipt_no,
  //         company: item?.production_work_order?.company?.name,
  //         product_code: item?.product?.code,
  //         planning_qty: item?.qty,
  //         production_qty: 0,
  //         return_qty: 0,
  //         transfer_qty: "",
  //         machine: item?.planning_for_glazing_and_jigger_item?.machine?.name,
  //         total_production_qty:
  //           productionTransferInfo[planningItemId]?.production_qty || 0, // Map production_qty
  //         total_transfer_qty: item?.total_transfer_qty || 0, // Map transfer_qty
  //         current_stock: productionTransferInfo[planningItemId]?.current_stock || 0, // Added current_stock
  //         slice_weight: item?.slice_weight, // Example if qty is used as slice_weight
  //         closing_balance: 0, // Placeholder for closing balance
  //         remarks_delivery: "", // Set to empty or adjust if needed
  //         decoration_code: item?.production_work_order_item?.decoration_code,
  //         decoration_name: item?.production_work_order_item?.decoration_name,
  //       };

  //       return existingItem || baseItem;
  //     });
  //     setList(updatedFilteredItems);
  //     setOriginalList(updatedFilteredItems);

  //     // Update the global map with new items (only if they don't already exist)
  //     setAllItemsWithInput((prevMap) => {
  //       const newMap = new Map(prevMap);
  //       updatedFilteredItems.forEach((item) => {
  //         if (!newMap.has(item.id)) {
  //           newMap.set(item.id, item);
  //         }
  //       });
  //       return newMap;
  //     });
  //     setLoading(false);
  //   }
  // };

  // Debounced search function that will execute the actual search after a delay
  const debouncedSearch = useCallback(
    async (searchValue, page = 1) => {
      setLoading(true);
      setShowPagination(false);

      if (searchValue.trim() === "") {
        // Restore original list when input is empty
        setList(originalList);
        setShowPagination(true);
        // Keep loading state for a moment to show the transition
        setTimeout(() => {
          setLoading(false);
        }, 300);
        return;
      }

      // Don't search if no planning is selected
      // if (!inputs.shortplan_id) {
      //   Swal.fire("Warning!", "Please select a planning first.", "warning");
      //   return;
      // }

      try {
        const response = await Http.post(`/search-products-for-jigger`, {
          search: searchValue,
          shortplan_id: inputs.shortplan_id, // Use planning_id from inputs
        });

        const productionTransferInfo =
          response?.data?.production_transfer_info || {};
        const filteredItems = response?.data?.items || [];

        const updatedFilteredItems = filteredItems.map((item) => {
          const planningItemId = item?.id;
          const existingItem = allItemsWithInput.get(item?.id);

          const baseItem = {
            id: item?.id,
            shortplan_id: inputs.shortplan_id,
            shortplan_item_id: item?.planning_for_glazing_and_jigger_item?.id,
            planning_id: inputs.planning_id,
            product_id: item?.product_id,
            product_name: item?.product?.name,
            shape: item?.shape?.name,
            production_work_order: item?.production_work_order?.receipt_no,
            company: item?.production_work_order?.company?.name,
            product_code: item?.product?.code,
            planning_qty: item?.qty || 0,
            production_qty: 0,
            return_qty: 0,
            transfer_qty: "",
            machine: item?.planning_for_glazing_and_jigger_item?.machine?.name,
            total_production_qty:
              productionTransferInfo[planningItemId]?.production_qty || 0,
            total_transfer_qty: item?.total_transfer_qty || 0,
            current_stock:
              productionTransferInfo[planningItemId]?.current_stock || 0,
            slice_weight: item?.slice_weight || "",
            green_weight: "",
            closing_balance: 0,
            remarks_delivery: "",
            decoration_code: item?.production_work_order_item?.decoration_code,
            decoration_name: item?.production_work_order_item?.decoration_name,
            glaze_id: item?.production_work_order_item?.glaze_id,
            status: item?.production_work_order?.status,
          };

          return existingItem || baseItem;
        });

        setList(updatedFilteredItems);

        // Update the global map with new items
        setAllItemsWithInput((prevMap) => {
          const newMap = new Map(prevMap);
          updatedFilteredItems.forEach((item) => {
            if (!newMap.has(item.id)) {
              newMap.set(item.id, item);
            }
          });
          return newMap;
        });
      } catch (error) {
        console.error("Error searching products:", error);
        const errorMessage =
          error.response?.data?.message || "Failed to search products.";
        Swal.fire("Error!", errorMessage, "error");

        // Restore original list on error
        setList(originalList);
      } finally {
        setLoading(false);
      }
    },
    [inputs.shortplan_id, inputs.planning_id, originalList, allItemsWithInput],
  );

  const selectHandleChanges = (selectedOption, actionMeta) => {
    const name = actionMeta.name;
    const value = selectedOption ? selectedOption.value : "";
    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));
    const newList = list.map((it) => ({ ...it, green_weight: 0 }));
    setList(newList);
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newList.forEach((it) => {
        newMap.set(it.id, { ...it });
      });
      return newMap;
    });
  };
  // Handle input change with debouncing
  const handleSearchProduct = (e) => {
    const searchValue = e.target.value;
    setSearchProducts(searchValue);

    // Always set loading to true when search input changes
    setLoading(true);

    // Clear any existing timeout
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    // Set a new timeout (2000ms delay before executing the search)
    searchTimeout.current = setTimeout(() => {
      debouncedSearch(searchValue);
    }, 2000);
  };

  const handleClickSearchProduct = () => {
    const data = [...list];
    setList(data);
  };

  const selectedFilterCake = filterCakeOptions.find(
    (o) => o.value == inputs.filter_cake_id,
  );
  const selectedStockQty = selectedFilterCake
    ? Number(selectedFilterCake.stockQty || 0)
    : 0;
  // Step 1: Compute aggregate value (green_weight * production_qty) for all items
  const aggregate = list.reduce((sum, it) => {
    const greenWeight = Number(it.green_weight / 1000) || 0;
    const productionQty = Number(it.production_qty) || 0;
    return sum + greenWeight * productionQty;
  }, 0);

  // Step 2: Calculate availableFilterCakeStock by subtracting aggregate (converted to kg) from selectedStockQty
  const availableFilterCakeStock = selectedStockQty - aggregate;

  return (
    <div>
      <IsLogin></IsLogin>

      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Production and Deliver</h5>
        </div>
        <div className="am-pagebody  row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 pt-3 col-11">
            <h6 className="card-body-title mg-sm-b-30 pb-3">
              Production and Delivery
            </h6>
            {/* <p>Transfer To Department {inputs.to_department}</p> */}
            <div
              className="row my-1 mb-2 fixed-header"
              style={{
                position: "sticky",
                top: "12%",
                width: "102.1%",
                marginBottom: "10px",
                zIndex: "1200",
                backgroundColor: "white",
                transition: "all 0.3s ease-in-out",
                transform: "translateY(0)",
              }}
            >
              <div className="col-lg  my-2">
                <label>Receipt No</label>
                <input
                  type="text"
                  className="form-control"
                  name="receipt_no"
                  value={inputs.receipt_no}
                  disabled
                />
              </div>
              <div className="col-lg my-2">
                <label>
                  Shift <i className="fa fa-star required"></i>
                </label>
                <select
                  className="form-control"
                  name="shift"
                  value={inputs.shift}
                  onChange={handleChange}
                  data-required
                >
                  <option value="">Select Shift</option>
                  <option value="a">A</option>
                  <option value="b">B</option>
                  <option value="c">C</option>
                  <option value="general">General</option>
                </select>
              </div>
              <div className="col-lg my-2">
                <label>
                  Entry Date <i className="fa fa-star required"></i>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="entry_date"
                  value={inputs.entry_date}
                  onChange={handleChange}
                  data-required
                />
              </div>
              <div className="col-lg" style={{ zIndex: 1000 }}>
                <label>
                  Filter Cake Type <i className="fa fa-star required"></i>
                </label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  name="filter_cake_id"
                  options={filterCakeOptions}
                  onChange={selectHandleChanges}
                  value={filterCakeOptions.find(
                    (option) => option.value == inputs.filter_cake_id,
                  )}
                />

                <span className="text-danger">{error.filter_cake_id}</span>
              </div>
              <div className="col-lg my-2">
                <label>Filter Cake Stock (kg)</label>
                <input
                  className="form-control"
                  type="text"
                  value={availableFilterCakeStock.toFixed(3)}
                  readOnly
                />
              </div>
            </div>

            <div
              className="row"
              style={{
                position: "sticky",
                top: "14%",
                width: "102.1%",
                marginBottom: "10px",
                zIndex: "1000",
                backgroundColor: "white",
                transition: "all 0.3s ease-in-out",
                transform: "translateY(0)",
              }}
            >
              <div className="col-lg my-2">
                <label>Search Product</label>
                <input
                  type="search"
                  className="form-control"
                  name="search_product"
                  placeholder="Search Product"
                  value={searchProducts}
                  onChange={handleSearchProduct}
                  onFocus={handleClickSearchProduct}
                />
              </div>
              <div className="col-lg my-2">
                <label>Remarks</label>
                <textarea
                  className="form-control"
                  name="remarks"
                  value={inputs.remarks}
                />
              </div>

              {!isSubmitting && (
                <div className="col-lg mt-5">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setIsSubmitting(true);
                      formSubmit();
                    }}
                  >
                    Submit
                  </button>
                </div>
              )}
              {isSubmitting && (
                <div className="col-lg mt-5">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setIsSubmitting(false)}
                  >
                    Regain Submit
                  </button>
                </div>
              )}
            </div>
            {/* Item List */}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row mt-3">
                  {/* {renderPagination()} */}
                  <div className="card-solid">
                    <div className="card-header with-border text-center mt-3">
                      <h5 className="card-title mb-0">
                        Items in the Production
                      </h5>
                    </div>
                  </div>
                  <div className="col-lg">
                    <table
                      className="table table-sm position-relative"
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      <thead
                        className="fixed-header"
                        style={{
                          position: "sticky",
                          top: "25%",
                          width: "104%",
                          marginBottom: "10px",
                          zIndex: "1000",
                          backgroundColor: "white",
                          transition: "all 0.3s ease-in-out",

                          transform: "translateY(0)",
                        }}
                      >
                        <tr>
                          <th>Product Name</th>
                          <th>Shape Name</th>
                          <th>Company Name</th>
                          <th>Planning Qty</th>
                          {role === "jigger" && (
                            <>
                              <th>Machine Name</th>
                            </>
                          )}
                          {role === "jigger" && (
                            <>
                              <th>Slice Weight</th>
                            </>
                          )}
                          <th>Green Weight</th>
                          {/* <th>Opening Qty</th> */}
                          <th>Available Qty</th>
                          <th>Total Production</th>
                          <th>Production Qty</th> {/* opening + rcved   */}
                          <th>Total Transfered</th>
                          <th>Transfer Qty</th>
                          {/* <th>Return Qty</th> */}
                          {/* <th>Closing Balance</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {list?.length < 1 ? (
                          <tr>
                            <td colSpan={13} className="text-center">
                              <ProgressSpinner />
                            </td>
                          </tr>
                        ) : (
                          list &&
                          list.map((item, index) => {
                            const rowKey = item?.id ?? index;
                            const rowStatusClass =
                              Number(item?.total_transfer_qty) >
                              Number(item?.planning_qty)
                                ? "bg-warning"
                                : Number(item?.total_transfer_qty) ==
                                    Number(item?.planning_qty)
                                  ? "bg-success  text-white"
                                  : "";

                            return (
                              <tr
                                key={index}
                                {...getRowProps(rowKey, rowStatusClass)}
                                style={{
                                  fontStyle:
                                    item?.status === "on_test"
                                      ? "italic"
                                      : undefined,
                                  fontWeight:
                                    item?.status === "on_test"
                                      ? "700"
                                      : undefined,
                                  border:
                                    item?.status === "on_test"
                                      ? "2px solid rgb(0, 89, 119)"
                                      : undefined,
                                }}
                              >
                                <td
                                  className={
                                    Number(item?.total_transfer_qty) >
                                    Number(item?.planning_qty)
                                      ? "text-dark"
                                      : Number(item?.total_transfer_qty) ==
                                          Number(item?.planning_qty)
                                        ? "text-white"
                                        : ""
                                  }
                                >
                                  {item.product_name} <br />
                                  <br />
                                </td>
                                <td
                                  className={
                                    Number(item?.total_transfer_qty) >
                                    Number(item?.planning_qty)
                                      ? "text-dark"
                                      : Number(item?.total_transfer_qty) ==
                                          Number(item?.planning_qty)
                                        ? "text-white"
                                        : ""
                                  }
                                >
                                  {" "}
                                  {item.shape}
                                </td>
                                <td
                                  className={
                                    Number(item?.total_transfer_qty) >
                                    Number(item?.planning_qty)
                                      ? "text-dark"
                                      : Number(item?.total_transfer_qty) ==
                                          Number(item?.planning_qty)
                                        ? "text-white"
                                        : ""
                                  }
                                >
                                  {" "}
                                  {item.company}
                                  <strong>
                                    #{item.production_work_order}
                                  </strong>{" "}
                                </td>
                                <td
                                  className={
                                    Number(item?.total_transfer_qty) >
                                    Number(item?.planning_qty)
                                      ? "text-dark"
                                      : Number(item?.total_transfer_qty) ==
                                          Number(item?.planning_qty)
                                        ? "text-white"
                                        : ""
                                  }
                                >
                                  {" "}
                                  {item.planning_qty}{" "}
                                </td>
                                {role === "jigger" && (
                                  <>
                                    <td
                                      className={
                                        Number(item?.total_transfer_qty) >
                                        Number(item?.planning_qty)
                                          ? "text-dark"
                                          : Number(item?.total_transfer_qty) ==
                                              Number(item?.planning_qty)
                                            ? "text-white"
                                            : ""
                                      }
                                    >
                                      {item.machine}{" "}
                                    </td>
                                  </>
                                )}

                                {role === "jigger" && (
                                  <>
                                    <td
                                      className={
                                        Number(item?.total_transfer_qty) >
                                        Number(item?.planning_qty)
                                          ? "text-dark"
                                          : Number(item?.total_transfer_qty) ==
                                              Number(item?.planning_qty)
                                            ? "text-white"
                                            : ""
                                      }
                                    >
                                      <input
                                        type="text"
                                        onInput={(e) =>
                                          (e.target.value =
                                            e.target.value.replace(/\D/g, ""))
                                        }
                                        className="form-control"
                                        name="slice_weight"
                                        value={list[index].slice_weight || ""}
                                        onChange={(e) =>
                                          handleInputChange(e, index)
                                        }
                                      />
                                    </td>
                                  </>
                                )}
                                <td
                                  className={
                                    Number(item?.total_transfer_qty) >
                                    Number(item?.planning_qty)
                                      ? "text-dark"
                                      : Number(item?.total_transfer_qty) ==
                                          Number(item?.planning_qty)
                                        ? "text-white"
                                        : ""
                                  }
                                >
                                  <input
                                    type="text"
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      ))
                                    }
                                    className="form-control"
                                    name="green_weight"
                                    value={list[index].green_weight || ""}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                    {...(Number(list[index]?.production_qty) > 0
                                      ? { "data-required": "" }
                                      : {})}
                                  />
                                </td>
                                <td
                                  className={
                                    Number(item?.total_transfer_qty) >
                                    Number(item?.planning_qty)
                                      ? "text-dark"
                                      : Number(item?.total_transfer_qty) ==
                                          Number(item?.planning_qty)
                                        ? "text-white"
                                        : ""
                                  }
                                >
                                  {(item.current_stock || 0) +
                                    Number(
                                      getGroupProductionQty(
                                        item.product_id,
                                        item.shape_id,
                                      ),
                                    ) -
                                    Number(
                                      getGroupTransferQty(
                                        item.product_id,
                                        item.shape_id,
                                      ),
                                    ) -
                                    Number(
                                      getGroupReturnQty(
                                        item.product_id,
                                        item.shape_id,
                                      ),
                                    )}
                                </td>
                                {/* <td
                                className={
                                  Number(item?.total_transfer_qty) >
                                  Number(item?.planning_qty)
                                    ? "text-dark"
                                    : Number(item?.total_transfer_qty) ==
                                      Number(item?.planning_qty)
                                    ? "text-white"
                                    : ""
                                }
                              >
                                {item.current_stock}
                              </td>
                              <td
                                className={
                                  Number(item?.total_transfer_qty) >
                                  Number(item?.planning_qty)
                                    ? "text-dark"
                                    : Number(item?.total_transfer_qty) ==
                                      Number(item?.planning_qty)
                                    ? "text-white"
                                    : ""
                                }
                              >
                                {item.total_production_qty -
                                  item.total_transfer_qty}
                              </td> */}
                                <td
                                  className={
                                    Number(item?.total_transfer_qty) >
                                    Number(item?.planning_qty)
                                      ? "text-dark"
                                      : Number(item?.total_transfer_qty) ==
                                          Number(item?.planning_qty)
                                        ? "text-white"
                                        : ""
                                  }
                                >
                                  {item.total_production_qty}{" "}
                                </td>

                                <td
                                  className={
                                    Number(item?.total_transfer_qty) >
                                    Number(item?.planning_qty)
                                      ? "text-dark"
                                      : Number(item?.total_transfer_qty) ==
                                          Number(item?.planning_qty)
                                        ? "text-white"
                                        : ""
                                  }
                                >
                                  <input
                                    type="text"
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      ))
                                    }
                                    className="form-control"
                                    name="production_qty"
                                    value={list[index].production_qty || ""}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                  />
                                </td>
                                <td
                                  className={
                                    Number(item?.total_transfer_qty) >
                                    Number(item?.planning_qty)
                                      ? "text-dark"
                                      : Number(item?.total_transfer_qty) ==
                                          Number(item?.planning_qty)
                                        ? "text-white"
                                        : ""
                                  }
                                >
                                  {item.total_transfer_qty}{" "}
                                </td>
                                <td
                                  className={
                                    Number(item?.total_transfer_qty) >
                                    Number(item?.planning_qty)
                                      ? "text-dark"
                                      : Number(item?.total_transfer_qty) ==
                                          Number(item?.planning_qty)
                                        ? "text-white"
                                        : ""
                                  }
                                >
                                  <input
                                    type="text"
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      ))
                                    }
                                    className="form-control"
                                    name="transfer_qty"
                                    value={list[index].transfer_qty}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                  />
                                </td>
                                {/* <td
                                className={
                                  Number(item?.total_transfer_qty) >
                                    Number(item?.planning_qty)
                                    ? "text-dark"
                                    : Number(item?.total_transfer_qty) ==
                                      Number(item?.planning_qty)
                                      ? "text-white"
                                      : ""
                                }
                              >
                                <input
                                  type="text"
                                  onInput={(e) =>
                                  (e.target.value = e.target.value.replace(
                                    /\D/g,
                                    ""
                                  ))
                                  }
                                  className="form-control"
                                  name="return_qty"
                                  value={list[index].return_qty || ""}
                                  onChange={(e) => handleInputChange(e, index)}
                                />
                              </td> */}
                                {/* <td
                                className={
                                  Number(item?.total_transfer_qty) >
                                  Number(item?.planning_qty)
                                    ? "text-dark"
                                    : Number(item?.total_transfer_qty) ==
                                      Number(item?.planning_qty)
                                    ? "text-white"
                                    : ""
                                }
                              >
                                {(item.current_stock || 0) +
                                  (list[index].production_qty || 0) -
                                  (list[index]?.transfer_qty || 0) -
                                  (list[index]?.return_qty || 0)}
                              </td> */}
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateJig;
